import React, {useEffect, useState, useRef} from 'react';
import {useTranslation} from "react-i18next";
import {Button, Checkbox, Form, Input, message, Select, Tabs } from 'antd';
import settings from "../services/settings.service";
import positionServer from "../services/position-server.service";

import './privateSettings.css';

const {Option} = Select;
const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};
const tailLayout = {
    wrapperCol: {offset: 8, span: 16},
};

/* -------------------------------------------------------------------------------- *\
|                               PanelHPv2Selection
\* -------------------------------------------------------------------------------- */
function PanelHPv2Selection({ hpv2List, selected, formHpv2Selection })
{
    const { t } = useTranslation();
    useEffect(() =>
    {
        formHpv2Selection.setFieldsValue({hpv2_uuid: `${selected.uuid}`});
        formHpv2Selection.setFieldsValue({is_hpv2_control_enabled: selected.isHpv2ControlEnabled});
    }, [formHpv2Selection, selected]);

    const onFinish = (values) =>
    {
        const positionServerUpdate =
        {
            uuid: values.hpv2_uuid,
            isHpv2ControlEnabled: values.is_hpv2_control_enabled,
            isSelected: true,
        };
        positionServer
            .update(positionServerUpdate)
            .then(res =>
            {
                if (res.status === 200 || res.status === 204)
                {
                    message.success(t('common.save_success'));
                    setTimeout(() => window.location.reload(), 2000);
                } else
                {
                    message.error(t('common.error'));
                }
            })
            .catch(() =>
            {
                message.error(t('common.error'));
            })
    }

    const hpv2GetLabel = (item) =>
    {
        return item.name + ' (' + item.url + ')';
    }

    return  <>
        <Form
            {...layout}
            form={formHpv2Selection}
            name="hpv2_selection_form"
            className="common_form"
            onFinish={onFinish}>

            <Form.Item name="hpv2_uuid" label={t('settings.hpv2_selection.hpv2_addr')} rules={[{required: true}]}>
                <Select onChange={(e) => formHpv2Selection.setFieldsValue({is_hpv2_control_enabled: hpv2List.find(hpv2 => hpv2.uuid === e).isHpv2ControlEnabled})}>
                    {hpv2List.map(hpv2 =>
                    {
                        return <Option key={hpv2.uuid} value={hpv2.uuid}>
                            {hpv2GetLabel(hpv2)}
                        </Option>
                    })}
                </Select>
            </Form.Item>

            <Form.Item name="is_hpv2_control_enabled" label={t('settings.hpv2_selection.hpv2_control_enabled')} valuePropName="checked">
                <Checkbox/>
            </Form.Item>

            <Form.Item {...tailLayout} className="form_toolbar">
                <Button type="primary" htmlType="submit">
                    {t('common.save')}
                </Button>
            </Form.Item>

        </Form>
    </>;
}

function PanelHPv2Configuration({formHpv2Settings}) {
    const {t} = useTranslation();

    const [mccMncList, setMccMncList] = useState([]);

    useEffect(() => {
        positionServer.getAllMccMnc().then(mccMncList => {
            setMccMncList(mccMncList.data);
        })
    }, [])

    const onFinish = (values) => {
        const settingsServerUpdate ={
            mode: Number(values.hpv2_mode),
            height_sensor: Number(values.hpv2_tracker_height),
            channel: Number(values.hpv2_channel),
            mccMnc: Number(values.hpv2_mcc_mnc),
            networkTechnology: Number(values.hpv2_network_technology)};
        positionServer
            .updateHpv2Settings(settingsServerUpdate)
            .then(res => {
                if (res.status === 200 || res.status === 204) {
                    message.success(t('common.save_success'));
                } else {
                    message.error(t('common.error'));
                }
            })
            .catch(() => {
                message.error(t('common.error'));
            })
    }

    return <>
        <Form
            {...layout}
            form={formHpv2Settings}
            name="hpv2_settings_form"
            className="common_form"
            onFinish={onFinish}>
            <fieldset>
                <legend>{t('settings.hpv2_settings.general_legend')}</legend>
                <Form.Item name="hpv2_mode" label={t('settings.hpv2_settings.hpv2_mode_label')} rules={[{required: true}]}>
                    <Select value="hpv2_mode">
                        <Option key="outdoor" value="1">
                            Outdoor
                        </Option>
                        <Option key="indoor" value="2">
                            Indoor
                        </Option>
                        <Option key="outdoor-fast" value="3">
                            Outdoor-Fast
                        </Option>
                        <Option key="outdoor-sync-gps" value="4">
                            Outdoor-SyncGPS
                        </Option>
                    </Select>
                </Form.Item>
                <Form.Item name="hpv2_tracker_height" label={t('settings.hpv2_settings.hpv2_tracker_height_label')} rules={[{required: true}]}>
                    <Input placeholder="" type="number"/>
                </Form.Item>
                <Form.Item name="hpv2_channel" label={t('settings.hpv2_settings.hpv2_channel_label')} rules={[{required: true}]}>
                    <Select value="hpv2_channel">
                        <Option key="hpv2_channel_1" value="1">
                            1
                        </Option>
                        <Option key="hpv2_channel_2" value="2">
                            2
                        </Option>
                        <Option key="hpv2_channel_3" value="3">
                            3
                        </Option>
                        <Option key="hpv2_channel_5" value="5">
                            5
                        </Option>
                    </Select>
                </Form.Item>
            </fieldset>
            <fieldset>
                <legend>{t('settings.hpv2_settings.network_legend')}</legend>
                <Form.Item name="hpv2_mcc_mnc"
                        label={t('settings.hpv2_settings.hpv2_mcc_mnc_label')}
                        rules={[{required: true}]}
                        extra="Orange : 20801 / SFR : 20810 / Bouygues Tel : 20820 / Free : 20815">
                    <Select value="hpv2_mcc_mnc">
                        {mccMncList.map(mccMnc => {
                            return <Option key={`${mccMnc.mcc}${mccMnc.mnc}`} value={`${mccMnc.mcc}${mccMnc.mnc}`}>
                                {mccMnc.countryCode + ' ' + mccMnc.brand + ' '+ mccMnc.mcc+mccMnc.mnc}
                            </Option>
                        })}
                    </Select>
                </Form.Item>
                <Form.Item name="hpv2_network_technology" label={t('settings.hpv2_settings.hpv2_network_technology_label')} rules={[{required: true}]}>
                    <Select value="hpv2_network_technology">
                        <Option key="hpv2_network_technology_3" value="3">
                            3G
                        </Option>
                        <Option key="hpv2_network_technology_4" value="4">
                            4G
                        </Option>
                    </Select>
                </Form.Item>
            </fieldset>
            <Form.Item {...tailLayout} className="form_toolbar">
                <Button type="primary" htmlType="submit">
                    {t('common.save')}
                </Button>
            </Form.Item>
        </Form>
    </>;
}
/* -------------------------------------------------------------------------------- *\
|                               PanelServerManager
\* -------------------------------------------------------------------------------- */
let g_indebug = false;
let g_inlogs = false;
function PanelServerManager()
{
    const {t} = useTranslation();
    const [debug, setDebug] = useState(false);
    const [logs, setLogs] = useState([]);
    const [inter, setInter] = useState(500);
    const [logtype, setLogtype] = useState("racing");
    const ref = useRef();

    useEffect(() =>
    {
        g_indebug = true;
        settings.getDebug().then((b) => { setDebug(b); g_indebug = false; });
        const interval = setInterval(() =>
        {
            if (g_indebug) return;
            g_indebug = true;
            settings.getDebug().then((b) => { setDebug(b); g_indebug = false; });
        }, 10000);
        return () => clearInterval(interval);
    }, []);
    useEffect(() =>
    {
        g_inlogs = true;
        settings.getLogs(logtype, 0)
            .then((l) =>
            {
                setLogs(l);
                setTimeout(() => { ref.current.scrollTop = ref.current.scrollHeight; }, 100);
            })
            .catch(function (error) { message.warning(error?.message); })
            .finally(() => { g_inlogs = false; });
    }, [logtype]);
    useEffect(() =>
    {
        const interval = setInterval(() =>
        {
            if (g_inlogs) return;
            g_inlogs = true;
            settings.getLogs(logtype, logs.length)
                .then((l) =>
                {
                    if (l.length > 0)
                    {
                        const isAtBottom = ref.current && (ref.current.clientHeight + ref.current.scrollTop) >= (ref.current.scrollHeight - 50);
                        setLogs([...logs, ...l]);

                        if (isAtBottom)
                        {
                            setTimeout(() => { ref.current.scrollTop = ref.current.scrollHeight; }, 100);
                        }
                        setInter(500);
                    }
                    else
                    {
                        setInter(5000);
                    }
                })
                .catch(function (error) { message.warning(error?.message); })
                .finally(() => { g_inlogs = false; });
        }, inter);
        return () => clearInterval(interval);
    // eslint-disable-next-line
    }, [logs, inter]);

    return <>
        <div className="server_manager">
            <fieldset className="server_manager_applications">
                <legend className="server_manager_title">{'Internal'}</legend>
                <div className="server_manager_application">
                    <div className="server_manager_label">Debug</div>
                    <div className="server_manager_debug">
                        <Button type="primary" size='small' htmlType="button" onClick={() => settings.setDebug(true).then(() => message.success(t('common.save_success')))}>Active</Button>
                        <Button type="primary" size='small' htmlType="button" onClick={() => settings.setDebug(false).then(() => message.success(t('common.save_success')))}>Inactive</Button>
                        <div className="server_manager_debug_value">{debug ? 'Active' : 'Inactive'}</div>
                    </div>
                </div>
                <legend className="server_manager_title">
                    <div>{'Logs'}</div>
                </legend>
                <div className="server_manager_logtype">
                    <div className={logtype === "racing" ? "active" : ""} onClick={() => setLogtype("racing")}>Racing</div>
                    <div className={logtype === "engine" ? "active" : ""} onClick={() => setLogtype("engine")}>Engine</div>
                    <div className={logtype === "mec" ? "active" : ""} onClick={() => setLogtype("mec")}>Mec</div>
                </div>
                <div className="server_manager_logs" ref={ref}>
                    {
                        logs.map((log, index) => {
                            return <div className="server_manager_log" key={'line_' + index}>{log}</div>;
                        })
                    }
                </div>
            </fieldset>
        </div>
    </>;
}
/* -------------------------------------------------------------------------------- *\
|                               PrivateSettings
\* -------------------------------------------------------------------------------- */
export default function PrivateSettings() {
    const {t} = useTranslation();
    const [formHpv2Selection] = Form.useForm();
    const [formHpv2Settings] = Form.useForm();
    const [hpv2List, setHpv2List] = useState([]);
    const [user, setUser] = useState({});
    const [hpv2Selected, setHpv2Selected] = useState({});

    // loadHpv2 ------------------------------------------------------
    const loadHpv2 = async () => {
        positionServer.getAll().then(positionsServers => {
            setHpv2List(positionsServers.data);
            const currentSelectedServer = positionsServers.data.find(server => server.isSelected === true);
            if (currentSelectedServer) {
                setHpv2Selected(currentSelectedServer);
            }
        });
    }

    const loadHpv2Settings = async () => {
        positionServer.getHpv2Settings().then(hpv2Settings => {
            if (hpv2Settings && hpv2Settings.data) updateHpv2SettingsFields(hpv2Settings.data);
        });
    }

    const updateHpv2SettingsFields = (hpv2Settings) => {
        formHpv2Settings.setFieldsValue({hpv2_mode: `${hpv2Settings.mode}`});
        formHpv2Settings.setFieldsValue({hpv2_tracker_height: hpv2Settings.height_sensor});
        formHpv2Settings.setFieldsValue({hpv2_channel: hpv2Settings.channel});
        formHpv2Settings.setFieldsValue({hpv2_mcc_mnc: `${hpv2Settings.mccMnc}`});
        formHpv2Settings.setFieldsValue({hpv2_network_technology: `${hpv2Settings.networkTechnology}`});
    }

    // useEffect ------------------------------------------------------
    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem('user')));
        loadHpv2();
        loadHpv2Settings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // render ---------------------------------------------------------
    const tabItems = [
        {
            key: "2",
            label: t('settings.hpv2_settings.title') + ` (${hpv2Selected.name})`,
            children: <PanelHPv2Configuration formHpv2Settings={formHpv2Settings} />
        },
        ...(user && user.roles && user.roles.includes("admin") ? [{
            key: "1",
            label: t('settings.hpv2_selection.title'),
            children: <PanelHPv2Selection hpv2List={hpv2List} selected={hpv2Selected} formHpv2Selection={formHpv2Selection} />
        }] : []),
        {
            key: "4",
            label: t('settings.server_manager.title'),
            children: <PanelServerManager/>
        }
    ];

    return (
        <div className="private_page_wrapper private-settings">
            <div className="header">
                <span className="title">{t('Menu.Settings')}</span>
            </div>
            <Tabs defaultActiveKey="2" items={tabItems} />
        </div>
    )

}
